var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.categories),function(category,i){return _c('v-btn',{key:i,attrs:{"text":"","color":"lightBlue"},on:{"click":function($event){return _vm.findProjects(category.name)}}},[_vm._v(_vm._s(category.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }